module.exports = __webpack_public_path__ + "img/moco.add62b3.png";